import React from 'react'
import PropTypes from 'prop-types'
import cls from 'classnames'

import styles from './Badge.module.scss'

function Badge({ content, className = '', position = 'left', appearance = 'default' }) {
  const bordersClass = position === 'left' ? styles.leftBadge : styles.rightBadge

  if (typeof content === 'string' && content.startsWith('icon-')) {
    return (
      <i
        className={cls(className, 'cred-icon', content, bordersClass, styles.badge, {
          [styles.fixedWidth]: appearance === 'default',
        })}
        data-testid="iconBadge"
      />
    )
  }
  return (
    <div
      className={cls(className, bordersClass, styles.badge, {
        [styles.fixedWidth]: appearance === 'default',
      })}
      data-testid="customBadge"
    >
      {content}
    </div>
  )
}

Badge.propTypes = {
  className: PropTypes.string,
  position: PropTypes.oneOf(['left', 'right']),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  appearance: PropTypes.oneOf(['default', 'compact']),
}

export default Badge
